module.exports = __webpack_public_path__ + "static/media/vieira.ed347594.jpg";